import React, { Component } from 'react'
import { Row, Col, Table, Button, Select, Spin, Cascader, Modal, Input, Icon, DatePicker, Pagination } from 'antd'
import { app, api, config } from "../../app"
import moment from "moment"
import '../../css/expert.css'
import Head from "../../components/Head"
import Iconz from "../../components/Iconz"
import utils from "../../utils"
import EMEdit from "./FMEdit"
import EMDetail from "./FMDetail"
import FLogin from "./FLogin"
import FRegister from "./FRegister"
import date_locale from 'antd/lib/date-picker/locale/zh_CN'

const Option = Select.Option
const Search = Input.Search

class EMList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isShowReg: false,
            toWeixin: '',
            isShowWeixin: false,
            isAdmin: false,
            showAdmin: false,
            data_loading: false,
            data_youke_loading: false, // 游客数据loading
            posi_loading: true,
            ppe_loading: true,
            dataList: [],
            positionalList: [],
            ppeList: [{ names: '全部', id: '0' }],
            positional_id: '0',
            positional_id2: '0', // 发布类型
            ppe_class_id: '0',
            search_key: '',
            edit_id: null,
            edit_modal: false,
            detail_loading: false,
            detail_modal: false,
            expert_info: {},
            total: 0,
            page: 1,
            page_youke: 1,
            total_youke: 0,
            regionsOptions: [],
            provinceRegions: [],
            xunrenType: [
                {
                    type_title: '家寻亲人',
                    type: 1,
                },

                {
                    type_title: '亲人寻家',
                    type: 2,
                },

                {
                    type_title: '感恩寻人',
                    type: 3,
                },

                {
                    type_title: '寻找老友',
                    type: 4,
                },

                {
                    type_title: '战友情深',
                    type: 5,
                },

                {
                    type_title: '台海寻人',
                    type: 6,
                },

                {
                    type_title: '其他寻人',
                    type: 7,
                }
            ],
            vistorDataList: [
                // {
                //     name: '赵东来',
                //     sex: '男',
                //     age: 18,
                //     height: 180,
                //     feature: '牛高马大，帅气逼人',
                //     id: 123,
                //     img: 'https://tp.blueskyrescue.cn/Uploads/Photo/20230223/63f7145981e2f.png',
                //     date: '2008-01-06',
                //     region: '河北省',
                //     region2: '石家庄市',
                //     // 唐山市
                // },
            ], // 游客无权限身份者查看页面数据
        }
    }

    componentDidMount() {
        // app.setData('findAsstoken', '');
        // 未登录也可查看寻人启事        
        // if (!app.getToken()) {
        //     this.props.history.replace('/')
        // }
        this._isMounted = true
        this.getRegions();
        this.positionalSource() // 获取寻找状态数据
        this.vistorDataSource(1) // 加载寻人大厅列表接口
        // console.log(app.getData('rights'));
        if (app.getData('rights') == '1' || app.getData('rights') == '2' || app.getData('rights') == '3') {
            // console.log("进来了");
            this.setData({
                isAdmin: true
            })
        } else {
            // console.log("没有进来");
            this.setData({
                isAdmin: false
            })
        }

        this.setData({
            toWeixin: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx807d86fb6b3d4fd2&redirect_uri=http%3A%2F%2Fdevelopers.weixin.qq.com&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect',
        })
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 列表数据(大厅·公开)
     * @param page
     */
    vistorDataSource = async (page = 1) => {
        await this.setData({ page_youke: page, data_youke_loading: true })
        const { positional_id, search_key } = this.state, params = {
            page,
            status: positional_id, // 状态（1寻找中；2已找到；3已撤销；4已逝世；5已过期）
            search: search_key,

            district: '', // 省/区
            search_type: '', // 搜索框类型(searchform_name, searchform_sex)
            search_val: '', // 搜索框值
            release_date: '', // 发布日期
        }
        let { flag, data, msg, total } = await app.post(api.LostMessageVistorLists, params)
        if (flag !== 1) {
            app.alert(msg, 'error')
            data = []
        }
        if (page === this.state.page_youke) {
            this.setData({ data_youke_loading: false, vistorDataList: utils.addArrayKey(data), total_youke: parseInt(total || 0) })
        }
    }

    /**
    * 列表数据(管理·需要权限)
    * @param page
    */
    adminDataSource = async (page = 1) => {
        await this.setData({ page: page, data_loading: true })
        const { positional_id, search_key } = this.state, params = {

            lost_token: app.getData("findAsstoken"),
            indexno: app.getData('indexno'),
            account: app.getData('account'),

            page,
            status: positional_id, // 状态（1寻找中；2已找到；3已撤销；4已逝世；5已过期）
            search: search_key,

            district: '', // 省/区
            search_type: '', // 搜索框类型(searchform_name, searchform_sex)
            search_val: '', // 搜索框值
            release_date: '', // 发布日期
            is_release: '', // 是否已发布（0否；1是）
        }
        let { flag, data, msg, total } = await app.post(api.LostMessageAdminLists, params);
        let data2 = [];
        if (flag !== 1) {
            app.alert(msg, 'error')
            data2 = []
        }
        if (data.length > 0) {
            data.forEach(e => {
                let obj = {
                    audit_reason: e.audit_reason,
                    audit_status: e.audit_status,
                    audit_time: e.audit_time,
                    create_time: e.create_time,
                    id: e.id,
                    lost_message_id: e.lost_message_id,
                    ...e.modify_content,
                };
                data2.push(obj);
            })
        }
        console.log(data2);
        if (page === this.state.page) {
            this.setData({ data_loading: false, dataList: utils.addArrayKey(data2), total: parseInt(total || 0) })
        }
    }

    // 跳转页
    handlePageChange = (page) => {
        console.log(page);
        this.vistorDataSource(page);
    }

    /**
     * 寻找状态数据
     */
    positionalSource = async () => {
        // const params = {
        //     indexno: app.getData('indexno'),
        //     account: app.getData('account'),
        // }
        let { flag, data, msg } = await app.post(api.LostMessageStatusLists, {})
        const state = { posi_loading: false }
        if (flag === 1) {
            state.positionalList = data.list
        } else {
            app.alert(msg, 'error')
        }
        this.setData(state)
    }

    /**
     * 地区数据
     */
    getRegions = async () => {
        const params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            type: 3
        }
        let { flag, data, msg } = await app.post(api.getCity, params)
        // console.log(data);
        const state = { ppe_loading: false }
        if (flag === 1) {
            let newData = [], provinceData = [];
            if (data.length > 0) {

                data.forEach((item, index) => {
                    let str = {
                        value: item.region_name,
                        label: item.region_name,
                    };
                    // console.log(item.sublevel);
                    if (item.sublevel !== '' && item.sublevel !== undefined) {
                        str.children = [];
                        item.sublevel.forEach((item2, index2) => {
                            let str2 = {
                                value: item2.region_name,
                                label: item2.region_name,
                            };
                            if (item2.sublevel !== '' && item2.sublevel !== undefined) {
                                str2.children = [];
                                item2.sublevel.forEach((item3, index3) => {
                                    let str3 = {
                                        value: item3.region_name,
                                        label: item3.region_name,
                                    };
                                    str2.children.push(str3);
                                })
                            }
                            str.children.push(str2);
                        })
                    }
                    newData.push(str);
                    provinceData.push({
                        value: item.region_id,
                        label: item.region_name,
                    });
                })
            }
            // console.log(newData);

            state.regionsOptions = newData
            state.provinceRegions = provinceData
        } else {
            app.alert(msg, 'error')
        }
        this.setData(state)
    }

    // 切换审核状态
    onChangeAudit = (e) => {
        console.log(e);
    }

    // 判断用户当前处于大厅还是管理页面，从而更新哪个表格数据
    onChangeXunRen = () => {

        // 管理页面
        if (!this.state.isAdmin) {
            this.adminDataSource(1);
        } else {
            // 大厅列表
            this.vistorDataSource(1);
        }
    }

    // 是否显示登录窗口
    showWeixinLogin = () => {
        const { isShowWeixin } = this.state;
        if (isShowWeixin) {
            this.setData({
                isShowWeixin: false
            })
        } else {
            this.setData({
                isShowWeixin: true
            })
        }
    }

    // 是否显示注册窗口
    showReg = () => {
        const { isShowReg } = this.state;
        if (isShowReg) {
            this.setData({
                isShowReg: false
            })
        } else {
            this.setData({
                isShowReg: true
            })
        }
    }

    /**
     * 详情数据
     */
    detailSource = async (id, id2) => {
        // console.log(id2); 选中列表的某一条数据
        const params = {
            id,
            lost_token: app.getData("findAsstoken")
        }
        let { flag, data, msg } = await app.post(api.LostMessageDetail, params)
        const state = { detail_loading: false }
        if (flag === 1) {
            let data2 = {
                ...data.audit_data,
                auditId: id2.id,
            }
            state.expert_info = data2;
        } else {
            app.alert(msg, 'error')
        }
        this.setData(state)
    }

    /**
     * 打开编辑框
     * @param edit_id
     */
    handleOpenEditModal = async (edit_id) => {
        console.log(app.getData('findAsstoken'));
        // 判断是否登录
        if (!app.getData('findAsstoken')) {
            app.alert("请先登录", 'warn')
            this.showWeixinLogin();
            return;
        }
        if (edit_id) {
            await this.setData({ edit_modal: true, edit_id, detail_loading: true })
            await this.detailSource(edit_id)
            // await this.setData({ edit_modal: true })
        } else {
            await this.setData({ edit_modal: true })
        }
    }

    /**
     * 打开详情框
     * @param id
     */
    handleOpenDetailModal = async (id, id2) => {
        await this.setData({ detail_modal: true, detail_loading: true })
        await this.detailSource(id, id2)
    }

    /**
     * 关闭编辑框
     */
    handleCloseEditModal = () => {
        this.setData({ edit_modal: false, edit_id: null, expert_info: {} })
    }

    /**
     * 关闭详情框
     */
    handleCloseDetailModal = () => {
        this.setData({ detail_modal: false, expert_info: {} })
    }

    /**
     * 编辑成功
     * @param values
     * @param id
     */
    handleEditSuccess = async (values, id) => {
        values.account = app.getData('account')
        values.indexno = app.getData('indexno')
        if (id) {
            values.id = id
            let { flag, msg } = await app.post(api.LostMessageAdminEdit, values)
            if (flag === 1) {
                app.alert(msg, 'success')
                await this.handleCloseEditModal()
                this.setData({
                    isShowWeixin: false,
                })
                // 调起寻人大厅列表接口
                setTimeout(() => {
                    this.vistorDataSource(this.state.page);
                }, 800);
                return true
            } else {
                app.alert(msg, 'error')
            }
        } else {
            let { flag, msg } = await app.post(api.LostMessageAdminAdd, values)
            if (flag === 1) {
                app.alert(msg, 'success')
                await this.handleCloseEditModal()
                this.setData({
                    isShowWeixin: false,
                })
                // 调起寻人大厅列表接口
                setTimeout(() => {
                    this.vistorDataSource(this.state.page);
                }, 800);
                return true
            } else {
                app.alert(msg, 'error')
            }
        }
        return false
    }

    // 计算年龄（仅计算年龄以及月龄）
    getAge(e) {
        let nowYear = new Date().getFullYear();
        let targetYear = Number(moment(e).format("YYYY"));
        // console.log(nowYear, targetYear);
        // return '8岁'
        // 如果是同一年，则判断月份
        if (nowYear === targetYear) {
            let nowMonth = new Date().getMonth() + 1;
            // 注意：getMonth返回值是0(1月)~11(12月)之间的一个整数，月份从0开始，11结束，0就是1月
            // moment().format("MM")也是如此
            let targetMonth = Number(moment(e).format("MM"));
            console.log(nowMonth, targetMonth, e);
            // 如果月份相同，则判断天数
            if (nowMonth === targetMonth) {
                return '未满月';
            } else {
                return nowMonth - targetMonth + '月';
            }
        } else {
            return nowYear - targetYear + '岁';
        }
    }

    // 通过审核or驳回
    auditOperation = async (id, type, reason) => {
        console.log(this.state.expert_info)
        let values = {
            account: app.getData('account'),
            indexno: app.getData('indexno'),
        };
        if (id === '') {
            app.alert("id不能为空", "warn");
            return;
        }
        values.id = id;
        values.lost_token = app.getData("findAsstoken");
        // type 1 通过 2 不通过
        if (type === 1) {
            values.audit_status = 1;
            let { flag, msg } = await app.post(api.LostMessageAdminAudit, values)
            if (flag === 1) {
                // 操作成功，关闭详细信息弹窗，重新加载寻人管理列表
                app.alert(msg, 'success')
                await this.handleCloseDetailModal()
                this.adminDataSource(this.state.page)
                return true
            } else {
                app.alert(msg, 'error')
            }
        } else {
            values.audit_reason = reason;
            values.audit_status = 2;
            let { flag, msg } = await app.post(api.LostMessageAdminAudit, values)
            if (flag === 1) {
                app.alert(msg, 'success')
                await this.handleCloseDetailModal()
                this.adminDataSource(this.state.page)
                return true
            } else {
                app.alert(msg, 'error')
            }
        }
        return false

    }

    // 调起注册接口
    handleRegisterSuccess = async (values) => {

        values.account = app.getData('account')
        values.indexno = app.getData('indexno')

        let { flag, msg } = await app.post(api.FindRegister, values)
        if (flag === 1) {
            app.alert(msg, 'success')
            this.closeRegOpenLogin();
            return true
        } else {
            app.alert(msg, 'error')
        }
    }

    // 调起登录接口
    toLogin = async (values) => {

        values.account = app.getData('account')
        values.indexno = app.getData('indexno')

        let { flag, msg, data } = await app.post(api.FindLogin, values)
        if (flag === 1) {
            app.alert(msg, 'success')
            app.setData('findAsstoken', data.token);
            app.setData('findName', data.vname);
            app.setData('findMobile', data.mobile);
            app.setData('findIdno', data.idno);
            this.setData({
                isShowWeixin: false,
            })
            // 调起寻人大厅列表接口
            setTimeout(() => {
                this.vistorDataSource(this.state.page);
            }, 800);
            return true
        } else {
            app.alert(msg, 'error')
        }
    }

    // 打开注册页面
    toRegister = () => {
        // 关闭登录页面同时再开启注册页面
        this.setData({
            isShowWeixin: false,
            isShowReg: true,
        })
    }

    // 打开登录页面
    closeRegOpenLogin = () => {
        // 关闭注册页面同时再开启登录页面
        this.setData({
            isShowWeixin: true,
            isShowReg: false,
        })
    }

    // 是否进入管理员页面
    showAdmibBtn = () => {
        const { showAdmin } = this.state;
        if (showAdmin) {
            // 返回大厅,清空值page total dataList，加载大厅列表接口
            this.setData({
                showAdmin: false,
                page: 1,
                total: 0,
                dataList: [],
                data_loading: false,
            })
            this.vistorDataSource();

        } else {
            // 进入管理页面，加载管理列表接口
            this.setData({
                showAdmin: true
            });
            this.adminDataSource();
        }
    }

    /**
     * 跳转详情
     * @param id
     */
    handleToDetail = (id) => {
        this.props.history.push('/find-detail/' + id)
    }


    /**
     * 查看我的发布
     * @param id
     */
    myFind = () => {
        // app.setData('findAsstoken', '')
        // console.log(app.getData('isLoginFind'))
        if (app.getData('findAsstoken')) {
            this.props.history.push("/myfind")
        } else {
            app.alert("请先登录", 'warn')
            this.showWeixinLogin();
        }
    }

    /**
     * 删除
     * @param id
     * @returns {Promise<void>}
     */
    handleRelieve = async (id) => {
        app.alert('正在加载', 'loading', '35%', 0)
        const params = {
            id,
            account: app.getData('account'),
            indexno: app.getData('indexno'),
            lost_token: app.getData('findAsstoken'),
        }
        let { flag, msg } = await app.post(api.LostMessageAdminDelete, params)
        app.alertDestroy()
        if (flag === 1) {
            app.alert(msg, 'success')
            await this.adminDataSource(this.state.page)
        } else {
            app.alert(msg, 'error')
        }

    }

    render() {
        let {
            dataList, showAdmin, isAdmin, positionalList, ppeList, data_loading, xunrenType, isShowReg, posi_loading, data_youke_loading, isShowWeixin, vistorDataList, regionsOptions, provinceRegions, edit_id, expert_info, edit_modal,
            detail_modal, detail_loading, total, page, page_youke, total_youke
        } = this.state,
            columns = [
                {
                    title: '基本信息',
                    dataIndex: 'img_path',
                    key: 'img_path',
                    width: 110,
                    render: (img) => {
                        return (
                            <img
                                style={{
                                    maxWidth: 84,
                                    width: 'auto',
                                    height: 'auto',
                                    maxHeight: 84,
                                }}
                                src={img !== '' ? config.imgUrl + img.split(":::")[0] : ''}
                                alt="头像"
                            />
                        )
                    }
                },
                {
                    title: '姓名',
                    dataIndex: 'name',
                    key: 'name',
                    width: 120
                },
                {
                    title: '性别',
                    dataIndex: 'sex',
                    key: 'sex',
                    width: 60
                },
                {
                    title: '年龄',
                    dataIndex: 'age',
                    key: 'age',
                    width: 60,
                    render: ((item, item2) => {
                        return (
                            <span>
                                {item2.birthday !== '' ? this.getAge(item2.birthday) : '-'}
                            </span>
                        )
                    })
                },
                {
                    title: '身高',
                    dataIndex: 'height',
                    key: 'height',
                    width: 60,
                    render: (item => {
                        return (
                            <span>
                                {item || '-'}cm
                            </span>
                        )
                    })
                },
                {
                    title: '地区',
                    dataIndex: 'sex',
                    key: 'sex',
                    width: 130,
                    render: ((item, meti) => {
                        return (
                            <span>
                                {meti.province || '-未知省-'}/{meti.city || '-未知市-'}
                            </span>
                        )
                    })
                },
                {
                    title: '事发地址',
                    dataIndex: 'address',
                    key: 'address',
                },
                {
                    title: '发布日期',
                    dataIndex: 'date',
                    key: 'date',
                    width: 160,
                },
                // {
                //     title: '有效日期',
                //     dataIndex: 'expiry_date',
                //     key: 'expiry_date',
                //     width: 120,
                // },

                {
                    title: '寻人状态',
                    dataIndex: 'flag_title',
                    key: 'flag_title',
                    width: 100
                },
                {
                    title: '操作',
                    dataIndex: 'lost_message_id',
                    key: 'lost_message_id',
                    width: 130,
                    render: (id, id2) => {
                        return (
                            <div>
                                {/* <div>
                                    {
                                        flag === '1' ? (
                                            <Button type="danger" size="small"
                                                onClick={() => this.handleRelieve(id)}>删除</Button>
                                        ) : (
                                            <Button type="primary" size="small"
                                                onClick={() => this.handleRelieve(id)}>通过</Button>
                                        )
                                    }
                                </div> */}
                                {/* <div style={{ margin: '.5rem 0' }}><Button type="primary"
                                    onClick={() => this.handleOpenEditModal(id)}
                                    size="small">编辑</Button></div> */}
                                <div><Button type="primary" onClick={() => this.handleOpenDetailModal(id, id2)}
                                    size="small">详情</Button></div>
                            </div>
                        )
                    }
                },
            ]
        return (
            <div className="expert-page" style={{ background: 'none' }}>
                <Head notLogin={(
                    <div className="frame-head-logo">
                        <Iconz type="icon-logo_" size={48} />
                    </div>
                )}
                    background="#3F89C1"
                    height={78}
                    history={this.props.history}
                />
                <div className="ep-content" style={{ maxWidth: '1180px', paddingTop: '40px', height: '100%' }}>
                    <div className="epc-title" style={{ position: 'relative' }}>
                        {
                            isAdmin && showAdmin ?
                                '寻人管理'
                                :
                                '寻人大厅'
                        }
                        <span onClick={() => this.showAdmibBtn()} style={{ display: isAdmin ? 'inline-block' : 'none', position: 'absolute', right: 0, bottom: 0, lineHeight: '14px', cursor: 'pointer', color: '#1890ff', fontWeight: 400, fontSize: 14 }}>
                            {
                                !showAdmin ?
                                    '进入管理'
                                    :
                                    '返回大厅'
                            }
                        </span>
                    </div>
                    <Row type="flex" justify="space-between" align="middle" className="ep-title">
                        <Col>
                            <Button type="default" icon="user"
                                onClick={() => this.myFind()}
                                style={{ marginRight: 8 }}
                            >个人中心</Button>
                        </Col>
                        <Col>
                            <Button type="primary" icon="user-add"
                                onClick={() => this.handleOpenEditModal()}>发布寻人启事</Button>
                        </Col>
                    </Row>
                    <Row type="flex" justify="space-between" className="epc-filter"
                        style={{ display: 'flex' }}
                    >
                        <Col>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>寻人状态：</div>
                                    <Select defaultValue="0" style={{ width: '6rem', fontSize: '.8rem', marginRight: '1rem' }}
                                        onChange={async (value) => {
                                            await this.setData({ positional_id: value })
                                            await this.onChangeXunRen()
                                        }}
                                        notFoundContent={posi_loading ? <Spin size="small" /> : null}
                                    >
                                        {
                                            positionalList.map(p => (
                                                <Option key={p.id} id={p.id}>{p.title}</Option>
                                            ))
                                        }
                                    </Select>
                                </div>
                                {/* <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>寻人类型：</div>
                                    <Select defaultValue="0" style={{ width: '6rem', fontSize: '.8rem', marginRight: '1rem' }}
                                        onChange={async (value) => {
                                            await this.setData({ positional_id2: value })
                                            await this.onChangeXunRen()
                                        }}
                                        notFoundContent={posi_loading ? <Spin size="small" /> : null}
                                    >
                                        {
                                            xunrenType.map(p => (
                                                <Option key={p.type} id={p.type}>{p.type_title}</Option>
                                            ))
                                        }
                                    </Select>
                                </div> */}
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: '1rem' }}>
                                    <div>走失地区：</div>
                                    <Cascader placeholder='请选择地区' style={{ width: '10rem' }} options={provinceRegions} />
                                    {/* onChange={(e) => this.onChangeRegions(e)}  */}
                                    {/* <Select defaultValue="0"
                                        style={{ width: '10rem', fontSize: '.8rem', marginRight: '1rem' }}
                                        onChange={async (value) => {
                                            await this.setData({ ppe_class_id: value })
                                            await this.dataSource(1)
                                        }}
                                        notFoundContent={ppe_loading ? <Spin size="small" /> : null}
                                    >
                                        <Option value="0">全部</Option>
                                        {
                                            ppeList.map(p => (
                                                <Option key={p.id} value={p.id}>{p.names}</Option>
                                            ))
                                        }
                                    </Select> */}
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: '1rem' }}>
                                    <div>发布日期：</div>
                                    <DatePicker style={{ width: "9rem" }} locale={date_locale}
                                        format="YYYY年MM月DD日" />
                                </div>
                                {
                                    isAdmin && showAdmin ?
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div>审核状态：</div>
                                            <Select defaultValue="0" style={{ width: '6rem', fontSize: '.8rem', }}
                                                onChange={(e) => this.onChangeAudit(e)}
                                            >
                                                <Option value="0">未审核</Option>
                                                <Option value="1">已审核</Option>
                                                <Option value="2">不审核</Option>
                                            </Select>
                                        </div>
                                        :
                                        null
                                }
                            </div>
                            {/* <span>职称筛选: </span>
                            <Select defaultValue="0" style={{ width: '10rem', fontSize: '.8rem' }}
                                onChange={async (value) => {
                                    await this.setData({ positional_id: value })
                                    await this.dataSource(1)
                                }}
                                notFoundContent={posi_loading ? <Spin size="small" /> : null}
                            >
                                <Option value="0">全部</Option>
                                {
                                    positionalList.map(p => (
                                        <Option key={p.value} value={p.value}>{p.title}</Option>
                                    ))
                                }
                            </Select>
                            <span style={{ marginLeft: '1rem' }}>专职筛选: </span>
                            <Select defaultValue="0" style={{ width: '10rem', fontSize: '.8rem' }}
                                onChange={async (value) => {
                                    await this.setData({ ppe_class_id: value })
                                    await this.dataSource(1)
                                }}
                                notFoundContent={ppe_loading ? <Spin size="small" /> : null}
                            >
                                <Option value="0">全部</Option>
                                {
                                    ppeList.map(p => (
                                        <Option key={p.id} value={p.id}>{p.names}</Option>
                                    ))
                                }
                            </Select> */}
                        </Col>
                        <Col>
                            <Input.Group compact>
                                <Select defaultValue="1">
                                    <Option value="1">男</Option>
                                    <Option value="2">女</Option>
                                </Select>
                                <Search placeholder="输入关键词搜索" style={{ width: '12.5rem', fontSize: '.8rem' }}
                                    onSearch={async (value) => {
                                        await this.setData({ search_key: value })
                                        await this.dataSource(1)
                                    }} />
                            </Input.Group>
                        </Col>
                    </Row>

                    {
                        showAdmin ?
                            <Table
                                columns={columns}
                                locale={app.tbLocale(data_loading)}
                                dataSource={dataList}
                                loading={data_loading}
                                // scroll={{ y: 'calc(100vh - calc(7rem + 181px))' }}
                                // style={{ height: 'calc(100% - calc(7rem + 78px))' }}
                                pagination={{
                                    total,
                                    current: page,
                                    pageSize: 20,
                                    showTotal: (t) => `总记录${t}条`
                                }}
                                className="table-odd-even-row"
                                size="small"
                            />
                            :
                            [
                                <div
                                    key='666'
                                    style={{
                                        alignItems: 'center',
                                        // backgroundColor: '#f2f2f2',
                                        flexWrap: 'wrap',
                                        borderRadius: '4px',
                                        display: vistorDataList.length == 0 ? 'none' : 'flex'
                                        // border: '2px solid #f2f2f2'
                                    }}>

                                    {
                                        data_youke_loading ? <Spin style={{ width: '100%' }} /> :

                                            vistorDataList.map((item, index) => (
                                                <div key={index}
                                                    className="xunrenbox"
                                                    style={{
                                                        width: 'calc(25% - 4px)',
                                                        backgroundColor: '#fff',
                                                        border: '2px dashed #f2f2f2',
                                                        cursor: 'pointer',
                                                        // borderRadius: '4px',
                                                        // height: 217,
                                                        margin: '2px',
                                                        padding: '10px'
                                                    }}
                                                    onClick={() => this.handleToDetail(item.id)}
                                                >
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            position: 'relative',
                                                            // border: '1px dashed #cccccc',
                                                            // borderRadius: '4px',
                                                            // width: '250px',
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                width: 118,
                                                                height: 166,
                                                                borderRadius: '4px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                border: '1px solid #fff',
                                                                backgroundColor: '#f9f9f9',
                                                            }}
                                                        >
                                                            <img
                                                                style={{
                                                                    maxWidth: 118,
                                                                    maxHeight: 166,
                                                                    // borderRadius: '4px'
                                                                    // border: '1px dashed #cccccc',
                                                                    // borderBottom: '1px dashed #cccccc',
                                                                }}
                                                                src={config.imgUrl + item.img_path.split(":::")[0]}
                                                                alt="头像"
                                                            />
                                                        </div>
                                                        <div style={{
                                                            width: 120,
                                                            paddingTop: 8,
                                                            paddingBottom: 8,
                                                            color: item.audit_status === 2 ? 'red' : '#fff',
                                                            backgroundColor: 'rgba(0,0,0,0.8)',
                                                            position: 'absolute',
                                                            bottom: 0,
                                                            left: 0,
                                                            textAlign: 'center'
                                                        }}>
                                                            {/* 未审核/不通过的显示审核状态 已审核的显示寻找状态 */}
                                                            {/* audit_status 0 未审核 1 已审核 2 不通过 */}
                                                            {/* find_title 寻找状态名称 */}
                                                            {
                                                                item.status === 1 ?
                                                                    <Icon type="file-search" />
                                                                    :
                                                                    <Icon type="audit" />
                                                            }
                                                            <span style={{
                                                                display: 'inline-block', marginLeft: 6
                                                            }}>
                                                                {item.flag_title || '-未知状态-'}
                                                            </span>
                                                        </div>
                                                        <div
                                                            style={{
                                                                marginLeft: '10px',
                                                                textAlign: 'initial',
                                                            }}
                                                        >
                                                            <div style={{
                                                                marginBottom: '4px', display: 'flex'
                                                                // justifyContent: 'center'
                                                            }}><span style={{ fontWeight: '600' }}>姓名：</span>
                                                                <span
                                                                    style={{
                                                                        textOverflow: 'ellipsis',
                                                                        overflow: 'hidden',
                                                                        whiteSpace: 'normal',
                                                                        'WebkitLineClamp': '2',
                                                                        width: '80px',
                                                                        'WebkitBoxOrient': 'vertical',
                                                                        display: '-webkit-box',
                                                                    }}
                                                                >
                                                                    {item.name || '-'}
                                                                </span>
                                                            </div>
                                                            <div style={{ marginBottom: '4px' }}><span style={{ fontWeight: '600' }}>性别：</span>{item.sex || '-'}</div>
                                                            <div style={{ marginBottom: '4px' }}><span style={{ fontWeight: '600' }}>年龄：</span>
                                                                {item.date !== '' ? this.getAge(item.date) : '-'}
                                                            </div>
                                                            <div style={{ marginBottom: '4px' }}><span style={{ fontWeight: '600' }}>身高：</span>{item.height || '-'}cm</div>
                                                            <div style={{
                                                                marginBottom: '4px', display: 'flex'
                                                                // justifyContent: 'center'
                                                            }}><span style={{ fontWeight: '600' }}>地区：</span> <span style={{
                                                                fontSize: 12,
                                                                textOverflow: 'ellipsis',
                                                                overflow: 'hidden',
                                                                whiteSpace: 'normal',
                                                                'WebkitLineClamp': '1',
                                                                width: '80px',
                                                                'WebkitBoxOrient': 'vertical',
                                                                display: '-webkit-box',
                                                            }}>{item.province || '-'}/{item.city || '-'}</span> </div>
                                                            <div ><span style={{ fontWeight: '600' }}>日期：</span>{item.date !== '' && item.date !== null ? moment(item.date).format('YYYY-MM-DD') : '-'}</div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className='xunrenbox_xianqing'
                                                        style={{
                                                            margin: '4px',
                                                            textOverflow: 'ellipsis',
                                                            overflow: 'hidden',
                                                            whiteSpace: 'normal',
                                                            'WebkitLineClamp': '2',
                                                            height: '40px',
                                                            'WebkitBoxOrient': 'vertical',
                                                            display: '-webkit-box',
                                                            marginTop: '10px',
                                                        }}>
                                                        <span style={{ fontWeight: '600' }}>特征：</span>
                                                        {item.feature || '-'}
                                                    </div>
                                                    <div
                                                        onClick={() => this.handleToDetail(item.id)}
                                                        className='xunrenbox_chagenkangeng'
                                                        style={{
                                                            margin: '4px',
                                                            height: '40px',
                                                            textAlign: 'center',
                                                            lineHeight: '40px',
                                                            color: '#fff',
                                                            backgroundColor: '#1890ff',
                                                            borderRadius: '4px',
                                                            marginTop: '10px',
                                                            justifyContent: 'center'
                                                        }}>
                                                        查看更多
                                                    </div>
                                                </div>
                                            ))

                                    }

                                </div>,
                                <div style={{ display: vistorDataList.length > 0 ? 'none' : 'block', textAlign: 'center' }}>
                                    暂无寻人数据
                                </div>,
                                <Pagination
                                    size="small"
                                    total={total_youke}
                                    pageSize={20}
                                    current={page_youke}
                                    // hideOnSinglePage={true}
                                    onChange={(e) => this.handlePageChange(e)}
                                    style={{ textAlign: 'center', marginTop: 10, paddingBottom: 10, paddingTop: 10, }}
                                />
                            ]
                    }

                </div>
                <Modal
                    maskClosable={false}
                    visible={isShowReg}
                    footer={null}
                    title={<span style={{
                        width: '100%',
                        textAlign: 'center'
                    }}>注册 · 寻人大厅</span>}
                    width="300px"
                    style={{ padding: 0, marginTop: '40px' }}
                    destroyOnClose={true}
                    onCancel={() => this.showReg()}
                >
                    <FRegister
                        info={edit_id ? expert_info : null}
                        ppes={ppeList}
                        regionsOptions2={regionsOptions}
                        positionals={positionalList}
                        success={this.handleRegisterSuccess}
                        logi={this.closeRegOpenLogin}
                    />
                </Modal>
                <Modal
                    maskClosable={false}
                    visible={isShowWeixin}
                    footer={null}
                    title={<span style={{
                        width: '100%',
                        textAlign: 'center'
                    }}>登录 · 寻人大厅</span>}
                    width="300px"
                    style={{ padding: 0, marginTop: '40px' }}
                    destroyOnClose={true}
                    onCancel={() => this.showWeixinLogin()}
                >
                    <FLogin
                        info={edit_id ? expert_info : null}
                        ppes={ppeList}
                        regionsOptions2={regionsOptions}
                        positionals={positionalList}
                        success={this.toLogin}
                        reg={this.toRegister}
                    />
                </Modal>
                <Modal
                    visible={edit_modal}
                    footer={null}
                    title={edit_id ? "编辑寻人启事" : '发布寻人启事'}
                    maskClosable={false}
                    width='840px'
                    centered
                    style={{ padding: 0, marginTop: '40px' }}
                    destroyOnClose={true}
                    // bodyStyle={{ height: '100vh', overflow: 'auto' }}
                    onCancel={this.handleCloseEditModal}
                >
                    {
                        detail_loading ? (
                            <div style={{ textAlign: 'center' }}><Spin size="large" /></div>
                        ) : (
                            <EMEdit
                                info={edit_id ? expert_info : null}
                                ppes={ppeList}
                                regionsOptions2={regionsOptions}
                                positionals={positionalList}
                                cancel={this.handleCloseEditModal}
                                success={this.handleEditSuccess}
                            />
                        )
                    }
                </Modal>
                <Modal
                    visible={detail_modal}
                    title='详细信息'
                    maskClosable={false}
                    width='1200px'
                    centered
                    style={{ padding: 0, top: 78 }}
                    destroyOnClose={true}
                    footer={false}
                    onCancel={this.handleCloseDetailModal}
                >
                    {
                        detail_loading ? (
                            <div style={{ textAlign: 'center' }}><Spin size="large" /></div>
                        ) : (<EMDetail
                            flagArr={positionalList}
                            info={expert_info}
                            audit={this.auditOperation}
                        />)
                    }
                </Modal>
            </div>
        )
    }
}

export default EMList


// WEBPACK FOOTER //
// ./src/routes/find/FMList.jsx